import classNames from 'classnames';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {Routes} from '../../../../Routes';

export function TestOrderLink(props) {
    const {className, dataTestId} = props;

    const intl = useIntl();

    const linkClasses = classNames('link', className);

    return (
        <NavLink
            className={linkClasses}
            data-test-id={dataTestId ?? 'account-menu-tests-link'}
            title={intl.formatMessage({id: 'accountMenu.link.tests.text'})}
            to={Routes.ACCOUNT_TESTS}
        >
            <span>
                <FormattedMessage id={'accountMenu.link.tests.text'} />
            </span>
        </NavLink>
    );
}
